import gql from 'graphql-tag';

export const GET_LISTING_SERVICES = gql`
	query GetListingServices($query: JSON, $regionId: String, $limit: Int, $offset: Int, $order: [[String]]) {
		services(query: $query, regionId: $regionId, limit: $limit, offset: $offset, order: $order) {
			id
			status
			address
			askingPrice
			squareFootage
			cubiCasaQuickEditLink
			cubiCasaAdvancedEditLink
			cubiCasaOrderId
			cubiCasaModelId
			matterportModelId
			agentNotes
			isAdminApproved
			type
			coverFile {
				id
				filename
				thumbnailUrl
				width
				height
			}
			orderInformation
			photographerNotes
			regionalManagerNotes
			editorNotes
			serviceDate
			surgeBoost
			includesMatterport
			property {
				id
				unitNumber
				address
				addressComponents
				alias
				baths
				beds
				city
				country
				googlePlaceId
				latitude
				longitude
				state
				streetAddress
				squareFootage
				timezone
				type
				unitNumber
				yearBuilt
				zipCode
			}
			bookedOptions {
				id
				name
				price
				quantity
				photographerCertificatesRequired
				editorCertificatesRequired
				packageType
				photographerPay
				traineePay
				additionalInfo
				additionalInfoType
			}
			isDroneService
			isTraining
			client {
				id
				email
				phoneNumber
				name
				notes
				image
			}
		}
	}
`;
